module.exports = __webpack_public_path__ + "img/shiba888-ic-mobile-left-1.0135c91e.png";